import ProviderSetup from './provider-setup';

const message = (key, fallback) => ({ key, fallback });

const config = {
  id: 'claude',
  name: 'Claude',
  description: message('claude_page_description', 'Manage your Brand2Social content from Claude and Claude Desktop.'),
  introduction: message('claude_introduction', 'Connect Claude to your organization to review posts, investigate failures and prepare or schedule social content using natural language.'),
  openUrl: 'https://claude.ai',
  openLabel: message('open_claude', 'Open Claude'),
  tabs: [
    {
      label: message('claude_web', 'Claude Web'),
      steps: [
        { title: message('claude_step1_title', 'Open Claude settings'), description: message('claude_step1_description', 'Open Claude, go to Settings and select Connectors.') },
        { title: message('claude_step2_title', 'Add a custom connector'), description: message('claude_step2_description', 'Choose Add custom connector and enter Brand2Social as the connector name.') },
        { title: message('claude_step3_title', 'Enter the server URL'), description: message('claude_step3_description', 'Paste the Brand2Social MCP server URL below and continue with OAuth.') },
        { title: message('claude_step4_title', 'Approve access'), description: message('claude_step4_description', 'Sign in to Brand2Social, choose your organization and approve the requested read or write access.') },
      ],
    },
    {
      label: message('claude_desktop', 'Claude Desktop'),
      steps: [
        { title: message('claude_desktop_step1_title', 'Open connector settings'), description: message('claude_desktop_step1_description', 'Open Settings in Claude Desktop and select Connectors.') },
        { title: message('claude_desktop_step2_title', 'Add a custom connector'), description: message('claude_desktop_step2_description', 'Add Brand2Social as a remote MCP connector.') },
        { title: message('claude_desktop_step3_title', 'Enter the server URL'), description: message('claude_desktop_step3_description', 'Paste the MCP server URL below and choose OAuth authentication.') },
        { title: message('claude_desktop_step4_title', 'Approve the organization'), description: message('claude_desktop_step4_description', 'Complete authorization in your browser and return to Claude Desktop.') },
      ],
    },
  ],
  prompts: [
    message('claude_prompt1', 'Show all posts waiting for approval.'),
    message('claude_prompt2', 'Review my recently published posts and their comments.'),
    message('claude_prompt3', 'Prepare a draft and schedule it for tomorrow at 10:00 AM.'),
  ],
};

export default function ClaudeConnection() {
  return <ProviderSetup config={config} />;
}
